import React, { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { batch, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';
import {
  GUEST_PORTAL_AUTH_FLOW,
  setGuestPortalAuthFlowAction,
  setGuestPortalIdAction,
  setShowMobileInfo,
} from 'store/app';
import axios from 'utils/axios';

function GuestPortalAuthFlowSetter() {
  const { guestPortalId } = useParams<{ guestPortalId: string }>();
  const authFlow = isNaN(Number(guestPortalId)) ? GUEST_PORTAL_AUTH_FLOW.ACCESS : GUEST_PORTAL_AUTH_FLOW.ORIGINAL;
  const dispatch = useDispatch();

  const { data, isSuccess, error } = useQuery(
    ['GP_ACCESS', guestPortalId],
    () => {
      if (authFlow === GUEST_PORTAL_AUTH_FLOW.ORIGINAL) {
        return { id: guestPortalId };
      }

      if (authFlow === GUEST_PORTAL_AUTH_FLOW.ACCESS) {
        return axios
          .get(`/guest_portals/accesses/${guestPortalId}`)
          .then((data) => data.data)
          .catch((e) => {
            throw new Error(e.errors.status);
          });
      }

      return null;
    },

    { staleTime: 5000 },
  );

  useEffect(() => {
    if (isSuccess) {
      batch(() => {
        dispatch(setGuestPortalIdAction(data?.id));
        dispatch(setGuestPortalAuthFlowAction(authFlow));
        dispatch(setShowMobileInfo(data.showMobileInfo));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (error && String(error).includes('404')) {
    return <ErrorScreen status="404_guest" />;
  }

  return <Loader isFillBlock />;
}

export default GuestPortalAuthFlowSetter;
